import React from 'react';
import { usePermission } from './PermissionProvider';

export default function Can({ code, anyOf, children, fallback = null }) {
  const { hasPermission, hasAnyPermission } = usePermission();

  if (anyOf?.length) {
    if (!hasAnyPermission(anyOf)) return fallback;
    return children;
  }
  if (!hasPermission(code)) return fallback;
  return children;
}
